import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import ATRClientTable from "./ATRClientTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import {
  DownloadButtonClient,
  DownloadExcelButtonClient,
} from "./DownloadButton";
import { annualTradesReportLocation } from "./Locations";
import { RouteComponentProps } from "react-router-dom";
import { useCurrentTradesReportFilter } from "../../../data/reports/annualTrade/hooks/useTradesReportFilter";

export interface ATRClientPageInfo {
  year: string;
}

export interface ATRClientPageProps
  extends RouteComponentProps<ATRClientPageInfo> {
  userAccessRights: AccessRights;
}

const ATRClientPage: React.FunctionComponent<ATRClientPageProps> = (props) => {
  const pageStyles = usePageStyles();

  // ovde su parametri za izvestaj
  // zbog toga stho se uzimaju iz URL-a moraju biti tipa string, ali ih konvertujem u number zbog toga sto to trazi API
  // dalje ih treba proslediti u odgovarajuci hook da bi se sacuvali u filteru u redux store-u
  const yearNumber = Number(props.match.params.year);
  console.log("Report params:", yearNumber);

  const [filter, setReportDate, setReportYear] = useCurrentTradesReportFilter();

  React.useEffect(() => setReportYear(yearNumber), [yearNumber]);

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={
                <PageTitle
                  title="aTReportClientTitle"
                  backLocation={annualTradesReportLocation}
                />
              }
              action={<AnnualActions />}
            />
            <Divider />
            <CardContent>
              <ATRClientTable userAccessRights={props.userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const AnnualActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <DownloadButtonClient />
    </Grid>
    <Grid item>
      <DownloadExcelButtonClient />
    </Grid>
  </Grid>
);

export default ATRClientPage;
